import { Helpers } from '../../helpers';
import { IOutputRate } from '../../interfaces/ioutput-rate';
import { ForecastHorizontal } from '../forecast-horizontal';

export class OutputRateBase {
  OutputRateId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_OutputRate?: Array<ForecastHorizontal> | null;

  constructor(item?: IOutputRate) {
    if (item) {

      this.OutputRateId = item.OutputRateId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_OutputRate = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_OutputRate);
    }
  }
}